import React from 'react';
import styled from 'styled-components';
import { YellowButton } from 'components/Buttons';

import { ResourceItemType } from '../types';

const ItemContainer = styled.li`
  padding: 25px 18px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.night};
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ItemTitle = styled.span`
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 500;
  font-family: 'DomaineDisplay';
  margin-right: 5px;
`;

const ListItem = (props: ResourceItemType) => {
  return (
    <ItemContainer>
      <ItemTitle>{props.title}</ItemTitle>
      <YellowButton as="a" href={props.url} target="_blank" rel="noreferrer">
        View
      </YellowButton>
    </ItemContainer>
  );
};

export default ListItem;
